export const neoskop = {
  name: 'Neoskop',
  adress: {
    street: 'Hanomaghof',
    houseNumber: 4,
    zip: '30449',
    city: 'Hannover',
    googleMapUrl: 'https://goo.gl/maps/VSV2ANuoAPJjWXD89'
  },
  contact: {
    phone: '+49 (511) 700 208-0',
    fax: '+49 (511) 700 208 90',
    mail: 'hallo@neoskop.de'
  },
  legal: {
    form: 'GmbH',
    managers: ['Maik Jablonski', 'Philipp Wanning'],
    court: 'Hannover',
    registerNumber: 'HRB 205945',
    ustId: 'DE271979782'
  },
  social: {
    instagram: {
      icon: 'instagram',
      account: '@neoskop',
      url: 'https://instagram.com/neoskop'
    }
  }
}
